import { render } from "./LayersPanel.vue?vue&type=template&id=05e73d62&scoped=true&ts=true"
import script from "./LayersPanel.vue?vue&type=script&lang=ts"
export * from "./LayersPanel.vue?vue&type=script&lang=ts"

import "./LayersPanel.vue?vue&type=style&index=0&id=05e73d62&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e73d62"]])

export default __exports__